import React, { useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import { Field } from "formik";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import InfoIcon from "@material-ui/icons/Info";
import HoverTooltip from "@Components/Tooltip/HoverTooltip";

import useStyles from "assets/jss/material-dashboard-react/components/inputStyle";
import ErrorMessage from "@Components/ErrorMessage";
import { InputAdornment, IconButton } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

const Input = (props) => {
  const { supportedTypes, maxCharacterLimit } = props;

  const { t } = useTranslation();
  const classesInner = useStyles();
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  let supportedTypeMessage;
  if (supportedTypes) {
    const modifiedSupportedTypes = supportedTypes.map((type) => `${type}`);
    supportedTypeMessage = modifiedSupportedTypes.join(", ");
  }

  const {
    label,
    name,
    required,
    messageboxrequired,
    // classes,
    labelClasses,
    errorMessage,
    password,
    disabledText,
    disabled,
    ...rest
  } = props;
  return (
    <Field name={name}>
      {(props) => {
        const { field, meta } = props;
        return (
          <>
            <InputLabel
              htmlFor={name}
              className={clsx(classesInner.label, {
                [classesInner.error]:
                  errorMessage || (meta.error && meta.touched),
                [labelClasses]: labelClasses,
              })}
            >
              {t(label)}
              {messageboxrequired ? <span style={{ color: "red" }}></span> : null}
              {required ? <span style={{ color: "red" }}> *</span> : null}
              {messageboxrequired ? (
                <HoverTooltip title={`${supportedTypeMessage}`}>
                  <IconButton style={{ padding: "0" }}>
                    <InfoIcon color="primary" />
                  </IconButton>
                </HoverTooltip>
              ) : null}
            </InputLabel>
            <TextField
              style={{ marginBottom: 8 }}
              name={name}
              type={password ? (showPassword ? "text" : "password") : "text"}
              error={Boolean(meta.touched) && Boolean(meta.error)}
              variant="outlined"
              placeholder={t("Enter ") + t(label)}
              {...rest}
              {...field}
              InputLabelProps={{ shrink: true }}
              fullWidth
              size="small"
              inputProps={{
                maxLength: maxCharacterLimit || 100, 
              }}
              helperText={`${field?.value?.length || 0}/${100}`}

              disabled={
                disabledText
                  ? disabledText.includes(field.value)
                  : false || disabled
              }
              InputProps={
                password
                  ? {
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="Toggle password visibility"
                            onClick={handleClickShowPassword}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }
                  : null
              }
            />
            {errorMessage || (meta.error && meta.touched) ? (
              <ErrorMessage
                message={errorMessage ? errorMessage : meta.error}
              />
            ) : null}
          </>
        );
      }}
    </Field>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  labelClasses: PropTypes.string,
  required: PropTypes.bool,
  messageboxrequired: PropTypes.bool,
  classes: PropTypes.string,
  name: PropTypes.string,
  errorMessage: PropTypes.array,
  field: PropTypes.object,
  meta: PropTypes.object,
  password: PropTypes.bool,
  disabledText: PropTypes.object,
  disabled: PropTypes.bool,
  supportedTypes: PropTypes.array,
  maxCharacterLimit: PropTypes.number,
};

export default Input;